import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Apollo } from "apollo-angular";
import { firstValueFrom } from "rxjs";
import { map } from "rxjs/operators";
import { RequestOptions } from "../../../../config/request-options";
import { ReassignEngagementRequest } from "../../../../models/request/reassign-engagement-request.model";
import { BooleanResponseWrapper } from "../../../../models/response/boolean-response-wrapper.model";
import { REASSIGN_ENGAGEMENT } from "../../../../gql/secure/v1/engagement/reassign";

/**
 * This file is generated from the metadata.json file. 
 * ** DO NOT edit this file manually **
 *
 * @example
 * ```
 * import { EngagementReassignApiService } from '@aiwyn-ai/gql-api/services/secure/v1/engagement/reassign-api.service';
 *
 * service = inject(EngagementReassignApiService);
 * ```
 */
@Injectable({ providedIn: 'root' })
export class EngagementReassignApiService {
    private readonly defaultBaseUrl: string = '/api';

    constructor(readonly apollo: Apollo, readonly http: HttpClient) {
    }

    /**
     * @param {ReassignEngagementRequest} reassignEngagementRequest - The reassignEngagementRequest to REASSIGN_ENGAGEMENT.
     * @param {RequestOptions} options - Optional configuration to use REST instead of GraphQL.
     * @returns {Promise<BooleanResponseWrapper>} A promise that resolves to the booleanResponseWrapper.,
     *
     * @example
     * ```
     * // Using GraphQL (default)
     * const result = await this.reassignEngagement(reassignEngagementRequest);
     *
     * // Using REST
     * const result = await this.reassignEngagement(reassignEngagementRequest, { useRest: true });
     * ```
     */
    async reassignEngagement(reassignEngagementRequest: ReassignEngagementRequest, options?: RequestOptions): Promise<BooleanResponseWrapper> {
        if (options?.useRest) {
            return this._reassignEngagementRest(reassignEngagementRequest, options.baseUrl);
        }
        return this._reassignEngagementGraphQL(reassignEngagementRequest);
    }

    private async _reassignEngagementGraphQL(reassignEngagementRequest: ReassignEngagementRequest): Promise<BooleanResponseWrapper> {
        return firstValueFrom(this.apollo.mutate({
            mutation: REASSIGN_ENGAGEMENT,
            variables: { reassignEngagementRequest },
        }).pipe(
            map((response: any) => response.data.ReassignEngagement),
        ));
    }

    private async _reassignEngagementRest(reassignEngagementRequest: ReassignEngagementRequest, baseUrl?: string): Promise<BooleanResponseWrapper> {
        const url = `${baseUrl ?? this.defaultBaseUrl}/secure/v1/engagement/reassign`;
        return firstValueFrom(
            this.http.post<BooleanResponseWrapper>(url, reassignEngagementRequest)
        );
    }
}
